module.exports = __webpack_public_path__ + "img/2_92.876c92f4.png";